var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionnaireDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Questionnaire_Details",
    "data-name": "Questionnaire Details",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.621,
    height: 15.31,
    viewBox: "0 0 12.621 15.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39460",
    "data-name": "Group 39460",
    transform: "translate(9.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39459",
    "data-name": "Group 39459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34242",
    "data-name": "Path 34242",
    d: "M356.324,0V2.276a1.036,1.036,0,0,0,1.034,1.034h2.276Z",
    transform: "translate(-356.324)",
    fill: "#39be9d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39462",
    "data-name": "Group 39462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39461",
    "data-name": "Group 39461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34243",
    "data-name": "Path 34243",
    d: "M55.318,4.345a2.075,2.075,0,0,1-2.069-2.069V0H44.973V13.241a2.075,2.075,0,0,0,2.069,2.069h8.483a2.075,2.075,0,0,0,2.069-2.069v-8.9Zm-3.724,6.724H47.87V10.034h3.724Zm3.1-2.483H47.869V7.552H54.7Z",
    transform: "translate(-44.973)",
    fill: "#39be9d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireDetails);
export default __webpack_public_path__ + "static/media/QuestionnaireDetails.a629637d5abb11bb5cae851bf38e8d38.svg";
export { ForwardRef as ReactComponent };